<div class="card">            
    <div class="card-body">
        <div class="tenant-user-board-body-table">
            <!-- <div class="example-loading-shade" *ngIf="isLoadingResults || isRateLimitReached">
                <mat-spinner *ngIf="isLoadingResults"></mat-spinner>
                <div class="example-rate-limit-reached" *ngIf="isRateLimitReached">
                    Squirrel's API rate limit has been reached. It will be reset in one minute.
                </div>
            </div> -->
            <user-management [paramTenant]="tenant"></user-management>
            <!-- <ag-grid-angular class="ag-theme-balham" style="width:100%;  height: calc(100vh - 430px);  padding: 0px;"
                [overlayLoadingTemplate]="overlayLoadingTemplate"
                [gridOptions]="gridOptions" 
                (gridReady)="onGridReady($event)"
                [components]="components" 
            </ag-grid-angular> -->
        </div>
    </div>
</div>